var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalAppliedInternship(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tablet-with-hand-svgrepo-com",
    transform: "translate(0 -2.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0 2.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M16.825,12.063H4.421a.556.556,0,1,0,0,1.111h12.4a.556.556,0,1,0,0-1.111Z",
    transform: "translate(0 -3.929)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M13.591,20.761c-.055-.145-.1-.275-.149-.41H1.522V4.315H16.017V17.569a.01.01,0,0,0,.007,0,.951.951,0,0,1,1.374-.038,1.286,1.286,0,0,1,.273-.029,1.32,1.32,0,0,1,.986.5V4.293c0-1.011-.567-1.83-1.267-1.83H1.266C.567,2.463,0,3.281,0,4.293V20.375c0,1.012.568,1.83,1.266,1.83H11.923a1.91,1.91,0,0,1,.024-.465,1.191,1.191,0,0,1,1.1-1.092A1.535,1.535,0,0,1,13.591,20.761Z",
    transform: "translate(0 -2.463)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M7.97,10.235a.208.208,0,0,0,.208-.209V6.138A.209.209,0,0,0,7.97,5.93H4.364a.21.21,0,0,0-.208.208v3.888a.21.21,0,0,0,.208.209Z",
    transform: "translate(0 -2.463)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M16.825,14.364H4.421a.556.556,0,1,0,0,1.112h12.4a.556.556,0,1,0,0-1.112Z",
    transform: "translate(0 -4.28)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M16.825,16.862H4.421a.557.557,0,0,0,0,1.114h12.4a.557.557,0,0,0,0-1.114Z",
    transform: "translate(0 -4.662)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M28.19,23.362A10.012,10.012,0,0,0,26.8,19.294a1.437,1.437,0,0,0-1.854-.689.988.988,0,0,0-1.6.166,1.008,1.008,0,0,0-1.62.4,36.552,36.552,0,0,1-2.151-3.24c-.506-.863-1.576-.426-.985.613,1.467,2.584,1.52,3.037,2.088,3.994.246.414,1.456,2.408.9,2.523-.5.1-1.1-1-1.99-1.293-1.4-.467-1.629.424-1.073.73a3.245,3.245,0,0,1,1.508,1.482c.131.248.972.428,1.243.59,1.771,1.055,1.992.848,2.7.857.769.012.891.438.891.438l3.481-1.738S28.2,23.558,28.19,23.362Z",
    transform: "translate(-8.33 -5.867)",
    fill: "#136ad0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAppliedInternship);
export default __webpack_public_path__ + "static/media/total-applied-internship.f0b91813fb3cd335612701928ea17b68.svg";
export { ForwardRef as ReactComponent };